import { createSelector } from 'reselect';
import { stringToArray } from 'utils';
import {
  BRANDS,
  SIZES,
  COLORS,
  PATTERNS,
  STYLES,
  CONTEXTS,
  AVAILABILITY,
  PRICE_TYPES,
  MIN_PRICE,
  MAX_PRICE,
  PRICE,
  IN_STORE,
  SIZE_LABELS,
} from 'constants/filters';
import { PROMO_DISCOUNT_TYPE } from 'constants/index';
import _xor from 'lodash/xor';

const filtersSelector = (productsModule) => productsModule.productFilters.filters;
const labelsSelector = (productsModule) => productsModule.productFilters.filterLabels;
const filterOptionsSelector = (productsModule) => productsModule.productFilterOptions.data;

const promotionsSelector = (productDetails) => productDetails.data?.promotions || productDetails.promotions;

const filterKeys = [BRANDS, SIZES, COLORS, PATTERNS, PRICE_TYPES, STYLES, CONTEXTS, AVAILABILITY, SIZE_LABELS];

export const getChosenFilters = createSelector(
  filtersSelector,
  labelsSelector,
  filterOptionsSelector,
  (filters, labels = {}, filterOptions = []) => {
    let chosenFilters = [];

    const moreFilterKeys = filterOptions ? _xor(filterKeys, Object.keys(filterOptions)) : [];
    const allFiltersKeys = [...filterKeys, ...moreFilterKeys];

    Object.keys(filters).forEach((key) => {
      if (allFiltersKeys.includes(key)) {
        const separator = key === SIZES || key === SIZE_LABELS ? '|' : ',';
        const categoryFilters = stringToArray(filters[key], separator).map((value) => ({
          key,
          value,
          label: labels[value],
        }));
        chosenFilters = [...chosenFilters, ...categoryFilters];
      }
    });

    if (filters[MIN_PRICE] || filters[MAX_PRICE]) {
      const min = filters[MIN_PRICE];
      const max = filters[MAX_PRICE];
      const minPrice = `${min && `${!max ? '> ' : ''}$${min}`}`;
      const maxPrice = `${max && `${!min ? '< ' : ''}$${max}`}`;
      const priceFilter = { key: PRICE, value: `${minPrice}${min && max && ' - '}${maxPrice}` };
      chosenFilters = [priceFilter, ...chosenFilters];
    }

    if (filters[IN_STORE]) {
      chosenFilters.push({
        key: IN_STORE,
        value: 'In My Store',
      });
    }

    return chosenFilters;
  },
);

export const getPercentOff = createSelector(promotionsSelector, (promotions) => {
  // 113 is the only type of promo to affect product price
  const discountEligiblePromotion = promotions?.find(({ type }) => String(type) === PROMO_DISCOUNT_TYPE);
  if (!discountEligiblePromotion) return null;
  return discountEligiblePromotion.percentOff;
});

export default getChosenFilters;
